import http from '@/utils/http'


export function getProgramTypes(params){
    return http.get('/program_types',{params})
}
export function addProgramTypes(data){
    return http.post('/program_types',data)
}
export function getProgramTypesDetail(id){
    return http.get(`/program_types/${id}`)
}
export function putProgramTypes(id,data){
    return http.put(`/program_types/${id}`,data)
}
export function deleteProgramTypes(id){
    return http.delete(`/program_types/${id}`)
}